// O-4755. A payout cap of 0 means "no cap", exactly as blank does — clearing a
// cap by typing zero must not cap the artist at nothing. The engine already
// reads it that way (FinancialSummaryMath#parseCapOrNull returns null unless the
// value is > 0), and the model validations accept 0.
//
// The UI has to agree, or it reports a cap that is not in force: a "Cap $0.00"
// chip on the deal terms card, Door Deal counted as configured, and — the one
// that costs money — V3DealBracketsEditor's cleanup effect skipping, so a
// `cap_overflow_target` left on a bracket survives to misroute a REAL cap set
// later. One predicate, so the five gates cannot drift from the engine again.
export const hasPayoutCap = (value) => {
  if (value == null || value === '') return false;
  // Commas stripped first, exactly as FinancialSummaryMath#parseMaskedInput does.
  // Number('1,250') is NaN, so a masked value read as "no cap" through the one
  // helper that exists to keep this in step with the engine.
  const parsed = parseFloat(String(value).replace(/,/g, ''));
  return Number.isFinite(parsed) && parsed > 0;
};
